// General
export const ENV_NAME = process.env.ENV_NAME;

// Application
export const GOOGLE_TAG_MANAGER_ID = process.env.GOOGLE_TAG_MANAGER_ID;

// For PDF
export const WEB_HOST = process.env.WEB_HOST;
export const SPS_HOST = process.env.SPS_HOST;
